import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import type { KeyboardPerfCapability } from '@rapoo/device-sdk'
import { useAdminOnly } from '@/composables/useAdminOnly'
import { useDeviceStore } from '@/stores/device'

/** 改键 / 行程：无权限时回退到灯光页 */
function guardKeyboardFeature(
  canShow: () => boolean,
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  if (!canShow()) {
    next({ name: 'keyboard-light' })
    return
  }
  next()
}

function canShowKeyboardPerformanceSettings(): boolean {
  const deviceStore = useDeviceStore()
  const keyboardPerf = deviceStore.currentDevice?.manifest.capabilities?.find(
    (capability): capability is KeyboardPerfCapability => capability.type === 'keyboardPerf',
  )
  return keyboardPerf?.config.enablePerformanceConfig === true
}

export const keyboardRoutes = [
  // Keyboard
  {
    path: 'keyboard',
    redirect: { name: 'keyboard-light' },
  },
  {
    path: 'keyboard/light',
    name: 'keyboard-light',
    meta: { type: 'keyboard' },
    component: () => import('@/views/device/keyboard/light/index.vue'),
  },
  {
    path: 'keyboard/keys',
    name: 'keyboard-keys',
    meta: { type: 'keyboard' },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext,
    ) => {
      const { canShowKeyboardKeys } = useAdminOnly()
      guardKeyboardFeature(() => canShowKeyboardKeys.value, to, from, next)
    },
    component: () => import('@/views/device/keyboard/keys/index.vue'),
  },
  {
    path: 'keyboard/performance-settings',
    name: 'keyboard-performance-settings',
    meta: { type: 'keyboard' },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext,
    ) => {
      guardKeyboardFeature(canShowKeyboardPerformanceSettings, to, from, next)
    },
    component: () => import('@/views/device/keyboard/perfConfig/index.vue'),
  },
  {
    path: 'keyboard/settings',
    name: 'keyboard-settings',
    meta: { type: 'keyboard' },
    component: () => import('@/views/device/keyboard/settings/index.vue'),
  },
  {
    path: 'keyboard/itinerary',
    name: 'keyboard-itinerary',
    meta: { type: 'keyboard' },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext,
    ) => {
      const { canShowKeyboardItinerary } = useAdminOnly()
      guardKeyboardFeature(() => canShowKeyboardItinerary.value, to, from, next)
    },
    component: () => import('@/views/device/keyboard/itinerary/entry.vue'),
  },
]
